import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter,
  infoFormatterIntl,
  localeFormatter,
} from '../../../../utils/formatters';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function IndividualEntrepreneurView({
  applicant = {}, prefix = '', fieldsValidation, isPreview, files = [],
}) {
  const {
    inn,
    address,
    phone,
    email,
    birth_date,
    gender,
    citizenship,
    registration_type,
    place_of_birth,
    snils,
    identity_type,
    identity_series,
    identity_number,
    identity_issuer,
    identity_issue_date,
    office_address,
    legal_entity_type,
    ogrn,
    first_name,
    middle_name,
    last_name,
  } = applicant;
  const {
    formatMessage,
  } = intlShape;

  const applicant_identity_files = files && files.length ? files.find(item => item.collection_name === 'applicant_identity_files') : undefined;

  function PreviewIndividualEntrepreneurView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('ogrnip', ogrn, fieldsValidation, 'ogrn')}
          {infoFormatterIntl('last_name', last_name, fieldsValidation, `${prefix}last_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('first_name', first_name, fieldsValidation, `${prefix}first_name`)}
          {infoFormatterIntl('middle_name', middle_name, fieldsValidation, `${prefix}middle_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('address', address, fieldsValidation, `${prefix}address`)}
          {infoFormatterIntl('home_address', office_address, fieldsValidation, `${prefix}office_address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', citizenship), fieldsValidation, `${prefix}citizenship`)}
        </Row>
      </>
    );
  }

  function FullIndividualEntrepreneurView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('ogrnip', ogrn, fieldsValidation, 'ogrn')}
          {infoFormatterIntl('last_name', last_name, fieldsValidation, `${prefix}last_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('first_name', first_name, fieldsValidation, `${prefix}first_name`)}
          {infoFormatterIntl('middle_name', middle_name, fieldsValidation, `${prefix}middle_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('registration_address', address, fieldsValidation, `${prefix}address`)}
          {infoFormatterIntl('home_address', office_address, fieldsValidation, `${prefix}office_address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('identity_type', localeFormatter('identity.type', identity_type), fieldsValidation, `${prefix}identity_type`)}
          {infoFormatterIntl('identity_series', identity_series, fieldsValidation, `${prefix}identity_series`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('identity_number', identity_number, fieldsValidation, `${prefix}identity_number`)}
          {infoFormatterIntl('identity_issue_date', dateFormatter(identity_issue_date), fieldsValidation, `${prefix}identity_issue_date`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('identity_issuer', identity_issuer, fieldsValidation, `${prefix}identity_issuer`)}
          {infoFormatterIntl('birth_date', dateFormatter(birth_date), fieldsValidation, `${prefix}birth_date`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('gender', localeFormatter('gender', gender), fieldsValidation, `${prefix}gender`)}
          {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', citizenship), fieldsValidation, `${prefix}citizenship`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('registration_type', localeFormatter('registration.type', registration_type), fieldsValidation, `${prefix}registration_type`)}
          {infoFormatterIntl('place_of_birth', place_of_birth, fieldsValidation, `${prefix}place_of_birth`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('snils', snils, fieldsValidation, `${prefix}snils`)}
          {infoFormatterIntl('applicant_identity_files', applicant_identity_files ? <FileView readOnly withoutMime withoutHr files={[applicant_identity_files]} /> : null, fieldsValidation, '', 6)}
        </Row>
      </>
    );
  }

  return isPreview ? <PreviewIndividualEntrepreneurView /> : <FullIndividualEntrepreneurView />;
}
